import { format } from 'date-fns';

type StringifyOptions = {
  dateFormat?: string;
};

export default function stringifyAny(meta?: any, { dateFormat }: StringifyOptions = {}): string {
  if (dateFormat && !Number.isNaN(Date.parse(meta))) {
    return format(new Date(Date.parse(meta)), 'dd-MM-yyyy');
  }
  if (!meta || typeof meta === 'string') {
    return meta;
  }

  return prettify(meta);
}

function prettify(metaField: any): string {
  let message = '';
  if (metaField instanceof Error) {
    message += metaField.toString();
  } else if (typeof metaField === 'string') {
    message += metaField;
  } else if (typeof metaField === 'object') {
    message += stringifyObject(metaField);
  } else {
    message += metaField;
  }
  return message;
}

function cleanupCyclicObject(_key: string, value: any): any {
  const seen: any[] = [];
  if (value != null && typeof value === 'object') {
    if (seen.indexOf(value) >= 0) {
      return '';
    }
    seen.push(value);
  }
  return value;
}

function stringifyObject(obj: Record<string, unknown>): string {
  return JSON.stringify(obj, cleanupCyclicObject);
}
